import React from 'react';
import ChooseDate from 'react-datepicker';
import moment from 'moment';

export default class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment().startOf('day'),
      value: '',
      active: false
    };
  }

  componentDidMount = () => {
    this.setState({
      date: moment.unix(this.props.date),
      startDate: moment.unix(this.props.startDate),
      endDate: moment.unix(this.props.endDate),
      value: this.props.date
    });
  };

  componentWillReceiveProps = nextProps => {
    this.setState({
      date: moment.unix(nextProps.date),
      startDate: moment.unix(nextProps.startDate),
      endDate: moment.unix(nextProps.endDate),
      value: nextProps.date
    });
  };

  render = () => {
    return (
      <div
        className={`datepicker-wrapper animated-text-form extended ${
          this.state.active ? 'active' : ''
        } ${this.props.className}`}
        ref={() => {
          this.returnSearchedValue = this.returnSearchedValue.bind(this);
        }}
      >
        <label
          htmlFor={'date-' + this.props.name}
          className="datepicker-label animated-text-label"
        >
          <span className="animated-text-label-name">
            {this.props.title}
            {this.props.required && '*'}
            {this.props.requiredRed && (
              <span style={{ color: '#f44336' }}>*</span>
            )}
          </span>
        </label>
        <img
          className="input-icon"
          src="/img/icons/search/calendar.svg"
          alt=""
        />
        <ChooseDate
          readOnly
          selected={this.state.date}
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onChange={this.handleChange}
          id={'date-' + this.props.name}
          onFocus={this.handleOnFocus}
          selectsEnd={this.props.selectsEnd}
          selectsStart={this.props.selectsStart}
          minDate={
            this.props.minDate ? this.props.minDate : moment().add(1, 'day')
          }
          onBlur={this.handleBlur}
          className="datepicker-element"
          locale="pl"
          withPortal={this.props.withPortal}
          fixedHeight
        />
      </div>
    );
  };

  handleOnFocus = () => this.setState({ active: true });

  handleBlur = () => this.setState({ active: false });

  handleChange = date => {
    let date_in_timestamp = moment(date._d)
      .startOf('day')
      .unix();
    this.setState({ date: date, value: date_in_timestamp }, () => {
      this.props.onChange(date_in_timestamp);
    });
  };

  returnSearchedValue = () => (this.state.value ? this.state.value : false);
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/datepicker.js